import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax

Vue.prototype.$eventBus = new Vue()

Vue.use(Vuesax);
import VueParticles from 'vue-particles';
Vue.use(VueParticles);

import DisableAutocomplete from '@aacassandra/vue-disable-autocomplete';

Vue.use(DisableAutocomplete);
Vue.prototype.$eventBus = new Vue()

// axios
import axios from "./axios.js"

Vue.prototype.$axios = axios;

// Crm request
import crm from "./request/crm-request.js"
Vue.prototype.$crm = crm;

// Oauth request
import oauth from './request/auth-request.js';
Vue.prototype.$oauth = oauth;

// Store request
import str from "./request/store-request.js"

Vue.prototype.$str = str;

//VBOT
import { VBotClient } from '/public/vbot-sdk'
Vue.prototype.$vbotSDK = VBotClient


//Map
const langMap = localStorage.getItem("language") ? localStorage.getItem("language") : 'vi-VN';
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'AIzaSyA5njGoEqNXvKLxaW2LFswk06x6eZG4S7E',
    libraries: 'places', // This is required if you use the Auto complete plug-in
    region: 'VI',
    // language: 'en',
    language: langMap == 'vi-VN' ? 'vi' : 'en',
  },
})



import * as VueGoogleMaps from "vue2-google-maps";

// Processor request
import processor from './request/processor-request.js';
Vue.prototype.$processor = processor;

import processorDemo from './request/processor-request-demo.js';
Vue.prototype.$processorDemo = processorDemo;

import processorDemoIp from './request/processor-request-demoIp.js';
Vue.prototype.$processorDemoIp = processorDemoIp;

// Camera request
import camera from './request/camera-request.js';
Vue.prototype.$camera = camera;

// API Calls
import "./http/requests"

// mock
import "./fake-db/index.js"

// Theme Configurations
import '../themeConfig.js'

// ACL
import acl from './acl/acl'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

//Scrollbar
import '@/assets/css/scrollbar.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

import routerPath from './store/constant'
Vue.prototype.$isPermission = routerPath;

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'

Vue.use(VueHammer);

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// i18n
import i18n from './i18n/i18n'

// Feather font icon
require('./assets/css/iconfont.css');

import firebase from 'firebase/app';
import "firebase/messaging";

if (firebase.messaging.isSupported()) {
    const config = {
        apiKey: "AIzaSyDOZ_Ymbf-DEEC7r3TxPK7XeYUv9B3BOhA",
        authDomain: "intface.firebaseapp.com",
        databaseURL: "https://intface.firebaseio.com",
        projectId: "intface",
        storageBucket: "intface.appspot.com",
        messagingSenderId: "1016522620600",
        appId: "1:1016522620600:web:d535f70e0dfbf62b5bfe4d",
        measurementId: "G-X2333RYQ7M"

        //Firebase test
        // apiKey: "AIzaSyANMCd7-kYl7WLAgU01EUm81_BWE8SnKMQ",
        // authDomain: "push-noti-demo-9f2b7.firebaseapp.com",
        // databaseURL: "https://push-noti-demo-9f2b7-default-rtdb.firebaseio.com",
        // projectId: "push-noti-demo-9f2b7",
        // storageBucket: "push-noti-demo-9f2b7.appspot.com",
        // messagingSenderId: "1012339158841",
        // appId: "1:1012339158841:web:8ae11435314525c68f02e8",
        // measurementId: "G-1JY4FVXR19"
    };
    firebase.initializeApp(config);

  Vue.prototype.$eventBus = new Vue()
  Vue.prototype.$messaging = firebase.messaging()

  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      Vue.prototype.$messaging.useServiceWorker(registration)
    }).catch(err => {
      console.log(err)
    })
}


// VeeValidate
import VeeValidate from 'vee-validate';
import messagesVn from './i18n/messages/vn.js';
import attributesVn from './i18n/attributes/vn.js';
import messagesEn from './i18n/messages/en.js';
import attributesEn from './i18n/attributes/en.js';
import I18n from "./layouts/components/navbar/components/I18n";

const phoneRule = {
  validate(value) {
    const mobilePhoneRule = /(0[3|5|7|8|9])+([0-9]{8})\b/;
    return mobilePhoneRule.test(value);
  }
};

const DEFAULT_TITLE = 'Dr Hoàng Tuấn';
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = DEFAULT_TITLE;
  });
});

VeeValidate.Validator.extend('phone_rule', phoneRule);

const lang = localStorage.getItem("language") ? localStorage.getItem("language") : 'vi-VN';
Vue.use(VeeValidate, {
  locale: lang == 'vi-VN' ? 'vn' : 'en',
  dictionary: {
    vn: {
      messages: messagesVn,
      attributes: attributesVn
    },
    en: {
      messages: messagesEn,
      attributes: attributesEn
    }
  }
});

Vue.use(VeeValidate, {
  locale: 'vn',
  dictionary: {
    vn: {
      messages: messagesVn,
      attributes: attributesVn
    },
    en: {
      messages: messagesEn,
      attributes: attributesEn
    }
  }
});

Vue.config.productionTip = false;

// import routerPath from '././././././constant/constant-router'

new Vue({
  router,
  store,
  acl,
  i18n,
  // routerPath,
  render: h => h(App)
}).$mount('#app');
